// extracted by mini-css-extract-plugin
export var description = "ImageWithText-module--description--63ad4";
export var fullImage = "ImageWithText-module--full-image--f4896";
export var imageWrapper = "ImageWithText-module--image-wrapper--a67de";
export var rightImage = "ImageWithText-module--right-image--b3d41";
export var root = "ImageWithText-module--root--5352b";
export var text = "ImageWithText-module--text--d106a";